export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || "";

// ── Google Maps loader ────────────────────────────────────────────
// Loads the Maps JS script once. Concurrent callers queue on the
// `callbacks` list and all resolve when the script finishes loading.
let googleMapsLoaded = false;
let googleMapsLoading = false;
let googleMapsCallbacks = [];

export function loadGoogleMaps() {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) { resolve(); return; }
    if (googleMapsLoaded) { resolve(); return; }
    googleMapsCallbacks.push(resolve);
    if (googleMapsLoading) return;
    googleMapsLoading = true;
    window.__googleMapsReady = () => {
      googleMapsLoaded = true;
      googleMapsCallbacks.forEach(cb => cb());
      googleMapsCallbacks = [];
    };
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&libraries=places,visualization&callback=__googleMapsReady`;
    script.async = true;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// Geocode an address using Google Geocoding API
export async function geocodeAddress(address, zip) {
  const fullAddress = `${address}, ${zip}`;
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(fullAddress)}&key=${GOOGLE_MAPS_KEY}`;
  try {
    const res  = await fetch(url);
    const data = await res.json();
    if (data.results && data.results[0]) {
      const r = data.results[0];
      const loc = r.geometry.location;
      // Return the confidence signals too so callers can stamp location_source/type
      // and flag fuzzy matches (GEOMETRIC_CENTER/APPROXIMATE/partial) for a manual pin.
      return { lat: loc.lat, lng: loc.lng, location_type: r.geometry.location_type || null, partial: !!r.partial_match };
    }
  } catch(e) { console.error("Geocode error:", e); }
  return null;
}

// SVG marker paths for each frequency shape (circle/diamond/star)
export function getMarkerSvg(color, shape, active) {
  const c   = active ? color : "#b3bac5";
  const enc = encodeURIComponent;
  if (shape === "circle") {
    return "data:image/svg+xml," + enc(`<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28'><circle cx='14' cy='14' r='11' fill='${c}' stroke='white' stroke-width='2.5'/></svg>`);
  }
  if (shape === "diamond") {
    return "data:image/svg+xml," + enc(`<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28'><rect x='6' y='6' width='16' height='16' rx='2' fill='${c}' stroke='white' stroke-width='2.5' transform='rotate(45 14 14)'/></svg>`);
  }
  if (shape === "star") {
    return "data:image/svg+xml," + enc(`<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30'><polygon points='15,3 18.5,11 27,12 21,18 22.5,27 15,23 7.5,27 9,18 3,12 11.5,11' fill='${c}' stroke='white' stroke-width='2'/></svg>`);
  }
  return "data:image/svg+xml," + enc(`<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28'><circle cx='14' cy='14' r='11' fill='${c}' stroke='white' stroke-width='2.5'/></svg>`);
}
